import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Truck, DollarSign, Package, Users, Calendar } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const icons = [Truck, DollarSign, Package, Users, Calendar];
export function WhyUs() {
  const {
    t
  } = useLanguage();
  return <AnimatedSection data-id="element-232">
      <div className="text-center mb-16" data-id="element-233">
        <h2 className="text-4xl md:text-5xl font-oswald font-bold mb-6" data-id="element-234">
          {t.whyUs.title}
        </h2>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-235">
          {t.whyUs.subtitle1} <br data-id="element-236" />
          <span className="text-barber-gold font-bold" data-id="element-237">
            {t.whyUs.subtitle2}
          </span>
        </p>
        <p className="mt-4 text-gray-400" data-id="element-238">{t.whyUs.subtitle3}</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-239">
        {t.whyUs.reasons.map((reason, index) => {
        const Icon = icons[index];
        return <div key={index} className="bg-barber-dark p-8 rounded-lg border border-white/5 relative overflow-hidden group hover:border-barber-gold/50 transition-colors" data-id="element-240">
              <div className="absolute top-0 right-0 text-9xl font-oswald font-bold text-white/[0.02] -mt-8 -mr-4 pointer-events-none" data-id="element-241">
                {index + 1}
              </div>
              <Icon className="text-barber-gold mb-6" size={40} data-id="element-242" />
              <h3 className="text-2xl font-oswald font-bold mb-3" data-id="element-243">
                {reason.title}
              </h3>
              <p className="text-gray-400" data-id="element-244">{reason.desc}</p>
            </div>;
      })}
      </div>
    </AnimatedSection>;
}